import Announcements from '../../Announcements/Announcements';
import DynamicIsland from '../../DynamicIsland/DynamicIsland';
import HeaderToolbar from '../../HeaderToolbar/HeaderToolbar';
import S from './HeaderStyles';

function Header(): JSX.Element {
  return (
    <S.Header>
      <Announcements />
      <DynamicIsland />
      <HeaderToolbar />
    </S.Header>
  );
}

export default Header;
